/**
 * Content Intelligence Lesson
 * Skill Area: Communication
 * Transform raw data into donor-ready narratives
 */

import type { LessonDefinition } from '../types';
import { CONTENT_INTELLIGENCE_AI_PROMPT, CONTENT_INTELLIGENCE_CONTEXT_SCENARIOS } from '../prompts/content-intelligence.prompt';

export const contentIntelligence: LessonDefinition = {
  id: 'content-intelligence',
  title: 'Content Intelligence',
  displayTitle: 'Surface Hidden Stories from Your Data',
  subTitle: 'Extract stories from existing materials',
  persona: 'Lyra',
  skillArea: 'Communication',
  topicId: 'communication-quality',
  topicTitle: 'Communication Quality & Voice',
  topicDescription: 'Verify outputs, keep your voice authentic, and build reusable comms systems.',
  format: 'tool_lab',
  difficulty: 'Intermediate',
  estimatedMinutes: 10,
  tags: ['storytelling', 'content', 'analysis'],
  dailyEligible: true,
  releasedAt: '2025-01-17T00:00:00.000Z',
  route: '/micro/content-intelligence',
  storyBeat: 'Transform dry data into donor-ready narratives.',
  introPrompt: "Your reports and data contain powerful stories. But buried in spreadsheets and PDFs, they never reach the people who need to hear them.",
  steps: [
    "Share raw data or materials that need transformation",
    "See the three narrative layers that make data compelling",
    "Watch your content transform through v1 → v2 → v3",
    "Master the refinement pattern for any future materials"
  ],
  promptGuidance: 'Paste data, report sections, or describe what materials you have.',
  contextScenarios: CONTENT_INTELLIGENCE_CONTEXT_SCENARIOS,
  aiPrompt: CONTENT_INTELLIGENCE_AI_PROMPT,
  inputPlaceholder: "Paste your data, report sections, or describe your materials...",
  quickPrompts: [
    'Program outcome data',
    'Survey results',
    'Participant testimonials',
    'Annual report numbers'
  ]
};
